export interface IProductConditionsProps {
  values: IProductCondition[];
  showTitle: () => boolean;
  isMobile?: boolean;
}

export enum ConditionEnum {
  NEW = 'new',
  USED = 'used',
}

export interface IProductCondition {
  name: ConditionEnum.NEW | ConditionEnum.USED;
  to: number;
  from: number;
  count: number;
}

export enum ProductConditionType {
  New,
  Used,
}
